export const LIST_PAYMENT_REMINDER_TAGS = 'LIST_PAYMENT_REMINDER_TAGS'
export const LIST_PAYMENT_REMINDER_TAGS_SUCCESS = 'LIST_PAYMENT_REMINDER_TAGS_SUCCESS'
export const LIST_PAYMENT_REMINDER_TAGS_FAILED = 'LIST_PAYMENT_REMINDER_TAGS_FAILED'
export const CLEAR_PAYMENT_REMINDER_TAGS = 'CLEAR_PAYMENT_REMINDER_TAGS'
